import apiClient from "../../../api-client";
import getWrappedUseMutation from "../../helpers/getWrappedUseMutation";

export const useSendEmailToAttendeesMutation = getWrappedUseMutation(apiClient.Email.attendees.put);
export const useSendEmailToAttendeeMutation = getWrappedUseMutation(apiClient.Email.attendee.put);
